export interface xy {
    x: number|null|undefined;
    y: number|null|undefined;
}

export default class DistanceHelper {
    static distance(pos1: xy, pos2: xy): number|null {
        if(pos1.x === null || pos1.x === undefined
            || pos2.x === null || pos2.x === undefined
            || pos1.y === null || pos1.y === undefined
            || pos2.y === null || pos2.y === undefined) {
            return null
        }
        return Math.sqrt(Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.y - pos2.y, 2))
    }
}